import { SignalDispatcher } from 'ste-signals';

export const transportRequestEvents = {
  onTransportCreated: new SignalDispatcher(),
  onTransportUpdated: new SignalDispatcher(),
  onSamplesAdded: new SignalDispatcher(),
  onSamplesRemoved: new SignalDispatcher(),
  addedToShipment: new SignalDispatcher(),
  removedFromShipment: new SignalDispatcher(),
};
